import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ToolConfirmRequest = components["schemas"]["ToolConfirmRequest"];

/** POST /v1/chat/runs/{id}/cancel — request cancellation of an active run. */
export async function cancelRun(runId: string): Promise<void> {
  unwrap(await api.POST("/v1/chat/runs/{id}/cancel", { params: { path: { id: runId } } }));
}

/** POST /v1/chat/runs/{run_id}/confirm — approve or cancel a pending tool proposal. */
export async function confirmRun(runId: string, body: ToolConfirmRequest): Promise<void> {
  unwrap(
    await api.POST("/v1/chat/runs/{run_id}/confirm", {
      params: { path: { run_id: runId } },
      body,
    }),
  );
}
